import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [TranslateModule]
})
export class FooterComponent implements OnInit {

  constructor() { }

  /**
   * @function ngOnInit Method to Initializes the component and perform initial operations
   */
  ngOnInit(): void {
  }

}
